import React from 'react';

const AboutSection = () => {
  return (
    <section
      id="about"
      className="relative py-32 px-6 flex justify-center"
    >
      <div className="max-w-4xl w-full text-center">

        {/* HEADING */}
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          About <span className="text-cyan-400 glow">Me</span>
        </h2>

        {/* SUBLINE */}
        <p className="text-gray-400 mb-12">
          Blending creativity, technology, and AI to build future systems
        </p>

        {/* CARD */}
        <div className="bg-[#111]/60 backdrop-blur-lg border border-cyan-400/20 rounded-2xl p-8 md:p-12 hover:border-cyan-400 transition-all duration-300 hover:shadow-[0_0_40px_rgba(0,255,255,0.2)]">

          <div className="text-gray-300 text-lg leading-relaxed space-y-5">

            <p>
              Hi, I’m Aaryan.
            </p>

            <p>
              I build things. Sometimes they work. Most times they turn into something better.
            </p>

            <p>
              I’m currently diving deep into AI, tech, and anything that lets me turn ideas in my head into something real. Half my life is spent thinking about the future, and the other half is trying to actually build it.
            </p>

            <p>
              I run projects, experiment with random ideas at 2AM, and occasionally question all my life decisions right before fixing them again.
            </p>

            <p>
              I’m also working on a mythology-inspired book series where I basically treat the universe like a game system ,because why not?
            </p>

            <p>
              Outside of that, you’ll probably find me listening to music, overthinking, or trying to figure out how to level up in life like it’s a skill tree.
            </p>

            <p>
              I’m not where I want to be yet ,but I’m definitely not staying where I started.
            </p>

            <p className="text-cyan-400 font-medium">
             The Journey , Not the Destination. - Aaryan's Mom
            </p>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutSection;